export const EXCMCONSENT_SHOW_RESET = 'EXCMCONSENT_SHOW_RESET'
export const EXCMCONSENT_SHOW_SET_ERROR = 'EXCMCONSENT_SHOW_SET_ERROR'
export const EXCMCONSENT_SHOW_SET_RETRIEVED = 'EXCMCONSENT_SHOW_SET_RETRIEVED'
export const EXCMCONSENT_SHOW_TOGGLE_LOADING = 'EXCMCONSENT_SHOW_TOGGLE_LOADING'
